import React from 'react';
import { Box, IconButton, Menu, MenuButton, MenuItem, MenuList, useDisclosure, } from '@chakra-ui/react';
import { PermissionGuard } from '../PermissionGuard/PermissionGuard';
import { localise } from '../../../services/lang/lang';
import KebabMenuIcon from '../../icons/KebabIcon/KebabIcon';
import { useTokens } from '../../../context/TokenProvider';
import { useManyDisclosureProxy } from '../../../hooks/state/useManyDisclosureProxy';
import { RenderIf } from '../RenderIf/RenderIf';
import { InvitedUsersTableDeleteModal } from './InvitedUsersTableDeleteModal';
import { InvitedUsersTableResendModal } from './InvitedUsersTableResendModal';
import { InvitedUsersTablePermissionsModal } from './InvitedUsersTablePermissionsModal';
export const InvitedUsersTableActionMenu = (props) => {
    const tokens = useTokens();
    const { buildOnClose, isOpen, buildOnOpen, onClose } = useManyDisclosureProxy({
        revoke: useDisclosure(),
        resend: useDisclosure(),
        permissions: useDisclosure(),
    });
    return (React.createElement(Box, null,
        React.createElement(Menu, { "data-testid": "invited-users-table-action-menu" },
            React.createElement(MenuButton, { as: IconButton, icon: React.createElement(KebabMenuIcon, null), colorScheme: tokens.Layer01, minHeight: "auto", height: "auto" }),
            React.createElement(MenuList, null,
                React.createElement(PermissionGuard, { permissions: ['users.set-roles'] },
                    React.createElement(MenuItem, { onClick: buildOnOpen('permissions') }, localise('ASSIGN_PERMISSIONS'))),
                React.createElement(PermissionGuard, { permissions: ['user-invites.resend'] },
                    React.createElement(MenuItem, { onClick: buildOnOpen('resend') }, localise('RESEND_INVITE'))),
                React.createElement(PermissionGuard, { permissions: ['user-invites.delete'] },
                    React.createElement(MenuItem, { onClick: buildOnOpen('revoke') }, localise('REVOKE_INVITE'))))),
        React.createElement(RenderIf, { condition: isOpen('permissions') },
            React.createElement(InvitedUsersTablePermissionsModal, { onUpdated: () => {
                    onClose('permissions');
                    props.onChange();
                }, onClose: buildOnClose('permissions'), invite: props.invite })),
        React.createElement(RenderIf, { condition: isOpen('resend') },
            React.createElement(InvitedUsersTableResendModal, { onClose: buildOnClose('resend'), onResend: () => {
                    onClose('resend');
                    props.onChange();
                }, invite: props.invite })),
        React.createElement(RenderIf, { condition: isOpen('revoke') },
            React.createElement(InvitedUsersTableDeleteModal, { onClose: buildOnClose('revoke'), onDeleted: () => {
                    onClose('revoke');
                    props.onChange();
                }, invite: props.invite }))));
};
